import { Dialog, DialogContent } from "@mui/material";
import "./UploadDocumentsDialog.scss";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { useEffect, useRef, useState } from "react";
import uploadImage from "../../../../../Assets/Registration/feather_upload-cloud-icon.svg";
import { useTranslation } from "react-i18next";
import {
  API_RESPONSE,
  COMMON_CONSTANTS,
  I18_TRANSLATION_COMMON,
  NUMBER_CONSTANTS,
  PERSONAL_INFORMATION,
  TOASTER_CONFIGS,
} from "../../../../Utilities/Constants/Constants";
import { ERROR_MESSAGES, REGISTRATION_ERRORS } from "../../../../Utilities/Constants/Validations";
import { S3DataGetApi, uploadFileToS3 } from "../../../../Services/Helpers/Helper";
import coverImageIcon from "../../../../../Assets/global/image-cover.svg";
import FileViewerDialog from "../../../../Shared/FileViewerDialog/FileViewerDialog";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import DownloadIcon from '@mui/icons-material/Download';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { setLoader } from "../../../../Services/Redux/Reducer/Reducer";
import { store } from "../../../../Services/Redux/Store/Store";
import { useSelector } from "react-redux";

const UploadDocumentDialog = (props: any) => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const uploadFileRef = useRef<HTMLInputElement | null>(null);
  const uploadFileBtnRef = useRef<HTMLInputElement | null>(null);
  const [uploadType, setUploadType] = useState("");
  const [dropEvent, setDropEvent]: any = useState();
  const [documentsList, setDocumentsList] = useState<any>([]);
  const [fileViewerOpen, setFileViewerOpen] = useState(API_RESPONSE.FALSE);
  const [viewerFile, setViewerFile] = useState("");
  const aws: any = useSelector((state: any) => {
    return state.awsReducer.aws;
  });

  useEffect(() => {
    if (props.editData) setDocumentsList(props.editData);
  }, [props]);

  /* Handling drag over */
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  /* Handling file drag */
  const handleDragEnter = (event: any) => {
    event.preventDefault();
  };

  /* Handling file drag leave */
  const handleDragLeave = (event: any) => {
    event.preventDefault();
  };

  const onCloseDialog = () => {
    setDocumentsList([]);
    props.handleClose();
  };

  useEffect(() => {
    if (dropEvent) {
      uploadType === PERSONAL_INFORMATION.DROP
        ? uploadFiles(dropEvent)
        : uploadFiles(dropEvent);
    }
  }, [dropEvent]);

  /* Validate uploading data format */
  const checkUploadType = (event: any, uploadingType: any) => {
    setUploadType(uploadingType);
    return new Promise((resolve, reject) => {
      const eventValue: any =
        uploadingType === PERSONAL_INFORMATION.DROP
          ? event.dataTransfer.files
          : event.target.files;

      const isValid: any = [...eventValue].every((media: any) => {
        if (
          media.type.split("/")[NUMBER_CONSTANTS.ONE] === COMMON_CONSTANTS.PDF
        ) {
          return API_RESPONSE.TRUE;
        }
        return API_RESPONSE.FALSE;
      });

      if (isValid) {
        resolve(API_RESPONSE.TRUE);
      } else {
        reject(REGISTRATION_ERRORS.PDF_FORMAT);
      }
    });
  };

  /* Handling file drop */
  const handleDrop = (event: any) => {
    event.preventDefault();
    event.nativeEvent.preventDefault();
    checkUploadType(event, PERSONAL_INFORMATION.DROP)
      .then((status) => {
        // setCurrentUpload(uploadValue);
        // setUploadType(PERSONAL_INFORMATION.DROP);

        setDropEvent(event);
      })
      .catch((error) => {
        toast.error(error);
        // toast.error('Pleas`e upload valid format');
      });
  };

  useEffect(() => { }, [documentsList]);

  /* Media upload function */
  const uploadFiles = async (file: any) => {
    // for (let i = 0; i < file?.length; i++) {
    try {
      store.dispatch(setLoader(true));
      const uploadedImage = await S3DataGetApi(file);
      setDocumentsList((documentsList: any) => [
        ...documentsList,
        uploadedImage,
      ]);
      store.dispatch(setLoader(false));
    } catch (error) { }
    // }
    // const uploadedImage: any = await uploadFileToS3(file);
    // setFiles(uploadedImage);
  };

  /* Handle File change */
  const handleChange = (event: any) => {
    store.dispatch(setLoader(true));
    event.preventDefault();
    event.nativeEvent.preventDefault();
    checkUploadType(event, PERSONAL_INFORMATION.SELECT)
      .then((status) => {
        setDropEvent(event);
        store.dispatch(setLoader(false));
      })
      .catch((error) => {
        toast.error(error);
        store.dispatch(setLoader(false));
        // toast.error('Please upload valid format');
      });
  };

  /**Handle file viewer dialog open */
  const onFilerViewerDialogOpen = (url: any) => {
    setViewerFile(url);
    setFileViewerOpen(API_RESPONSE.TRUE);
  };

  /**Handle file viewer dialog close */
  const onFilerViewerDialogClose = () => {
    setFileViewerOpen(API_RESPONSE.FALSE);
    setViewerFile("");
  };

  /* Delete image from documents list */
  const onDeleteImage = (id: any) => {
    let data = documentsList;
    data.splice(id, NUMBER_CONSTANTS.ONE);
    setDocumentsList([...data]);
  };

  /* Upload document API call */
  const onSubmit = () => {
    let payload = {
      document: documentsList,
      time_slot_id: props.data ? props.data : props.listSelectedSlot,
    };

    if (documentsList.length > NUMBER_CONSTANTS.ZERO) {
      axiosInstance
        .put(API_END_POINTS.DISCOUNT_FILTER_DATA, payload)
        .then((response) => {
          toast.success(response.data.message, TOASTER_CONFIGS);
          onCloseDialog();
        });
    } else {
      toast.error(ERROR_MESSAGES.UPLOAD_DOCUMENT);
    }
  };

  /* Downloading file function */
  const onDownloadFile = (donwnloadLink: any) => {
    fetch(donwnloadLink)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);

        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        link.download = donwnloadLink.split("/")[donwnloadLink.split("/").length - 1];

        // Append the link to the document
        document.body.appendChild(link);

        // Trigger a click on the link to initiate the download
        link.click();

        // Remove the link from the document
        document.body.removeChild(link);

        // Revoke the Blob URL to free up resources
        window.URL.revokeObjectURL(url);
        toast.success(ERROR_MESSAGES.DOWNLOADED_SUCCESSFULLY, TOASTER_CONFIGS);
      })
      .catch(error => console.error(ERROR_MESSAGES.DOWNLOAD_ERROR, error));
  }

  return (
    <div className="upload-document-dialog">
      <FileViewerDialog
        open={fileViewerOpen}
        handleClose={onFilerViewerDialogClose}
        viewerFile={viewerFile}
      ></FileViewerDialog>

      <Dialog open={props.open} className="dialog-wrapper">
        <div className="dialog-close-icon">
          <CloseIcon onClick={onCloseDialog} />
        </div>
        <p className="dialog-form-label">Upload Documents</p>

        <DialogContent>
          <div className="upload-dialog-content">
            <div className="row row-wrap">
              <div className="col-md-12">
                <div
                  className="form-items"
                  onDragOver={handleDragOver}
                  onDrop={(e: any) => {
                    handleDrop(e);
                  }}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  ref={uploadFileRef}
                >
                  {/* <label className="form-label required-field">{t("")}</label> */}
                  <div className="upload-file-wrapper">
                    <div className="upload-content">
                      <img src={uploadImage} />
                      <div className="text-content">
                        <p className="select-text">
                          Slecet a file or drag and drop here
                        </p>
                        <p className="file-text ms-3">
                          PDF filesize not more than 10MB
                        </p>
                      </div>
                      <input
                        type="file"
                        multiple={true}
                        accept="application/pdf"
                        className="input-upload"
                        onChange={(e: any) => {
                          handleChange(e);
                        }}
                        ref={uploadFileBtnRef}
                        style={{ display: "none" }}
                      />
                    </div>
                    <button
                      className="select-file-btn"
                      onClick={() => {
                        uploadFileBtnRef.current?.click();
                      }}
                    >
                      SELECT FILE
                    </button>
                  </div>
                  {documentsList?.length > NUMBER_CONSTANTS.ZERO && (
                    <div>
                      <p className="file-added-text">File Added:</p>
                      {documentsList?.map((image: any, index: any) => {
                        return (
                          <div className="upload-image-list" key={index + 1}>
                            <div className="image-text-wrap">
                              <img src={coverImageIcon} />
                              <p>
                                {image.split("/")[image.split("/").length - 1]}
                              </p>

                            </div>
                            <div >
                              <RemoveRedEyeIcon className="icons-wrap" onClick={() => {
                                // onFilerViewerDialogOpen(image);
                                window.open(image, '_blank')
                              }} />
                              <DownloadIcon className="icons-wrap" onClick={() => {
                                onDownloadFile(image);
                              }} />
                              <CloseIcon className="icons-wrap"
                                onClick={() => {
                                  onDeleteImage(index);
                                }}
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              <div className="dialog-button-wrapper mt-3">
                <button className="btn btn-secondary" onClick={onCloseDialog}>
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={onSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default UploadDocumentDialog;
